import React, { useState } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { Document } from '../../types/Document';

interface DocumentFormProps {
  initialValues: Document;
  onSave: (document: Document, files?: { de?: File; fr?: File; it?: File }) => void;
  onCancel: () => void;
}

export default function DocumentForm({ initialValues, onSave, onCancel }: DocumentFormProps) {
  const [selectedFiles, setSelectedFiles] = useState<{
    de?: File;
    fr?: File;
    it?: File;
  }>({});

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values: Document, { setSubmitting }: FormikHelpers<Document>) => {
        onSave(values, selectedFiles);
        setSubmitting(false);
      }}
    >
      {(formik) => (
        <Form onSubmit={formik.handleSubmit}>
          {/* German Section */}
          <div className="border-bottom pb-4 mb-4">
            <h5 className="mb-3">German Version</h5>
            <Form.Group className="mb-3" controlId="file_de">
              <Form.Label>Document File (DE)</Form.Label>
              <Form.Control
                type="file"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setSelectedFiles((prev) => ({ ...prev, de: file }));
                    formik.setFieldValue('filename', file.name);
                  }
                }}
              />
              {formik.values.storageUrl && !selectedFiles.de && (
                <div className="small mt-2">
                  Aktuelles Dokument:
                  {' '}
                  <a href={formik.values.storageUrl} target="_blank" rel="noreferrer">
                    {formik.values.filename || (formik.values.storageUrl.split('/').pop() || 'Datei (DE)')}
                  </a>
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="title">
              <Form.Label>Title (DE)</Form.Label>
              <Form.Control
                type="text"
                {...formik.getFieldProps('title')}
              />
            </Form.Group>
          </div>

          {/* French Section */}
          <div className="border-bottom pb-4 mb-4">
            <h5 className="mb-3">French Version</h5>
            <Form.Group className="mb-3" controlId="file_fr">
              <Form.Label>Document File (FR)</Form.Label>
              <Form.Control
                type="file"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setSelectedFiles((prev) => ({ ...prev, fr: file }));
                    formik.setFieldValue('filename_fr', file.name);
                  }
                }}
              />
              {formik.values.storageUrl_fr && !selectedFiles.fr && (
                <div className="small mt-2">
                  Document actuel:
                  {' '}
                  <a href={formik.values.storageUrl_fr} target="_blank" rel="noreferrer">
                    {formik.values.filename_fr || (formik.values.storageUrl_fr.split('/').pop() || 'Fichier (FR)')}
                  </a>
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="title_fr">
              <Form.Label>Title (FR)</Form.Label>
              <Form.Control
                type="text"
                {...formik.getFieldProps('title_fr')}
              />
            </Form.Group>
          </div>

          {/* Italian Section */}
          <div className="mb-4">
            <h5 className="mb-3">Italian Version</h5>
            <Form.Group className="mb-3" controlId="file_it">
              <Form.Label>Document File (IT)</Form.Label>
              <Form.Control
                type="file"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setSelectedFiles((prev) => ({ ...prev, it: file }));
                    formik.setFieldValue('filename_it', file.name);
                  }
                }}
              />
              {formik.values.storageUrl_it && !selectedFiles.it && (
                <div className="small mt-2">
                  Documento attuale:
                  {' '}
                  <a href={formik.values.storageUrl_it} target="_blank" rel="noreferrer">
                    {formik.values.filename_it || (formik.values.storageUrl_it.split('/').pop() || 'File (IT)')}
                  </a>
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="title_it">
              <Form.Label>Title (IT)</Form.Label>
              <Form.Control
                type="text"
                {...formik.getFieldProps('title_it')}
              />
            </Form.Group>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
